require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/fn/get-iterator.js
// module id = 1025
// module chunks = 1